<div class="container">
  <h1 mat-dialog-title *ngIf="isEditMode">
    {{ isUnverified ? 'Card Verification Needed' : 'Edit ' + paymentAccount.userDescription }}
  </h1>

  <p id="addPaymentAccount-text-unverifiedNotice" *ngIf="isUnverified">Please ask the rider for the security code and billing address associated with the following card:</p>
  <p id="addPaymentAccount-text-expiredNotice" *ngIf="isExpired" class="expired">
    This card has expired. In order to use it, you will need to delete this payment method and add a new one with an updated expiration date.
  </p>

  <h3 *ngIf="!isUnverified">Card Details</h3>
  <form [formGroup]="creditCardForm" autocomplete="off">
    <div class="column">
      <mat-form-field *ngIf="!isUnverified" appearance="outline" class="nickname">
        <mat-label>Account Nickname</mat-label>
        <input
          id="addPaymentAccount-input-accountNickName"
          matInput
          placeholder="Pick a name for this account"
          type="text"
          name="userDescription"
          formControlName="userDescription"
          autocomplete="off"
        />
      </mat-form-field>
      <div class="row" *ngIf="!isUnverified">
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          <input
            id="addPaymentAccount-input-firstName"
            matInput
            type="text"
            name="billingFirstName"
            formControlName="billingFirstName"
            autocomplete="off"
            data-private="lipsum"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          <input
            id="addPaymentAccount-input-lastName"
            matInput
            type="text"
            name="billingLastName"
            formControlName="billingLastName"
            autocomplete="off"
            data-private="lipsum"
          />
        </mat-form-field>
      </div>
      <ng-container *ngIf="isEditMode; else cardInputs">
        <div class="row hidden-card-number">
          <img [src]="cardTypeIcon" />
          <p id="addPaymentAccount-text-maskedCardNumber" >****&emsp;{{ paymentAccount.cardNumber }}</p>
        </div>
        <div class="row">
          <div>
            <h3 *ngIf="isUnverified">Security Code</h3>
            <mat-form-field appearance="outline" class="cvv flex-1">
              <mat-label>Security Code</mat-label>
              <input
                id="addPaymentAccount-input-securityCode"
                matInput
                type="tel"
                ccCVC
                formControlName="cardVerificationValue"
                autocomplete="off"
                data-private="lipsum"
              />
              <img matSuffix src="/assets/cvv.svg" />
              <mat-error *ngIf="isEditMode && creditCardForm.controls.cardVerificationValue.invalid">Please re-enter security code</mat-error>
            </mat-form-field>
          </div>
          <div *ngIf="isUnverified" class="flex-2 spacer"></div>
          <mat-form-field *ngIf="!isUnverified" appearance="outline" class="flex-1">
            <mat-label>Expiration Date</mat-label>
            <input
              id="addPaymentAccount-input-expirationDate"
              matInput
              type="tel"
              ccExp
              formControlName="cardExpiration"
              autocomplete="off"
              data-private="lipsum"
            />
            <mat-hint>MM/YYYY</mat-hint>
          </mat-form-field>
        </div>
      </ng-container>
      <ng-template #cardInputs>
        <div class="row">
          <mat-form-field appearance="outline" class="card-number flex-2">
            <mat-label>Card Number</mat-label>
            <img matPrefix [src]="cardTypeIcon" />
            <input
              id="addPaymentAccount-input-cardNumber"
              matInput
              type="tel"
              ccNumber
              formControlName="cardNumber"
              autocomplete="off"
              data-private="lipsum"
            />
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="outline" class="cvv flex-1">
            <mat-label>Security Code</mat-label>
            <input
              id="addPaymentAccount-input-securityCode"
              matInput
              type="tel"
              ccCVC
              formControlName="cardVerificationValue"
              autocomplete="off"
              data-private="lipsum"
            />
            <img matSuffix src="/assets/cvv.svg" />
            <mat-error *ngIf="isEditMode && creditCardForm.controls.cardVerificationValue.invalid">Please re-enter security code</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Expiration Date</mat-label>
            <input
              id="addPaymentAccount-input-expirationDate"
              matInput
              type="tel"
              ccExp
              formControlName="cardExpiration"
              autocomplete="off"
              data-private="lipsum"
            />
            <mat-hint>MM/YYYY</mat-hint>
          </mat-form-field>
        </div>
      </ng-template>
      <ng-container *ngIf="isCreditCardValidationEnabled">
        <h3>Billing Address</h3>
        <mat-form-field appearance="outline">
          <mat-label>Street Address</mat-label>
          <input
            id="addPaymentAccount-input-streetAddress"
            matInput
            type="text"
            formControlName="billingStreetAddress1"
            data-private="lipsum"
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Apt, suite, etc (optional)</mat-label>
          <input
            id="addPaymentAccount-input-streetAddress2"
            matInput
            type="text"
            formControlName="billingStreetAddress2"
            data-private="lipsum"
          />
        </mat-form-field>
        <div class="row city-state-zip">
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input
              id="addPaymentAccount-input-city"
              matInput
              type="text"
              formControlName="billingCity"
              data-private="lipsum"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select id="addPaymentAccount-select-state" formControlName="billingState" data-private="lipsum">
              <mat-option id="addPaymentAccount-option-{{state.code}}" *ngFor="let state of states" [value]="state.code">
                {{ state.code }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Zip Code</mat-label>
            <input
              matInput
              type="number"
              id="addPaymentAccount-input-zipCode"
              formControlName="billingZipCode"
              data-private="lipsum"
            />
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </form>
  <mat-card-actions align="end">
    <button id="addPaymentAccount-button-cancel" mat-button (click)="handleCancel()">Cancel</button>
    <button
      id="addPaymentAccount-button-delete"
      *ngIf="paymentAccount.id"
      mat-raised-button
      color="warn"
      style="margin-left: 2em"
      (click)="deletePaymentAccount()"
    >
      Delete
    </button>
    <button
      *ngIf="!isExpired"
      id="addPaymentAccount-button-save"
      mat-raised-button
      color="primary"
      style="margin-left: 2em"
      [disabled]="!creditCardForm.valid || submittingPaymentAccount"
      uzDebounceClick
      [debounceTime]="500"
      (debounceClick)="submitPaymentAccount()"
    >
      <mat-progress-spinner *ngIf="submittingPaymentAccount" [mode]="'indeterminate'" [diameter]="20" [strokeWidth]="2">
      </mat-progress-spinner>
      {{ isUnverified ? 'Verify' : 'Save'}}
    </button>
  </mat-card-actions>
</div>
